import dateService from '@gem/services/date-service';

export const prepareValue = (value: string, min: string, max: string): string => {
  const time = dateService.parseTime(value) as number[] | null;
  const minTime = dateService.parseTime(min) as number[] | null;
  const maxTime = dateService.parseTime(max) as number[] | null;

  if (!time || (!minTime && !maxTime)) {
    return value;
  }

  let isLess = false;
  let isMore = false;

  time.some((v: number, i: number) => {
    if (
      minTime &&
      time[i] < minTime[i] &&
      !Array(i)
        .fill(0)
        .some((_: number, j: number) => minTime[j] !== time[j])
    ) {
      isLess = true;
      return true;
    }

    if (
      maxTime &&
      time[i] > maxTime[i] &&
      !Array(i)
        .fill(0)
        .some((_: number, j: number) => maxTime[j] !== time[j])
    ) {
      isMore = true;
      return true;
    }

    return false;
  });

  if (isLess || isMore) {
    return isLess ? min : max;
  }

  return value;
};
